import React from "react";
import MenuItem from "./MenuItem";

import { Button, Drawer } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

interface SidebarProps {
  data: Object[];
  navigateToFirstChild?: boolean; // auto visit first child of dropdown menu
}

export const Sidebar = ({
  data,
  navigateToFirstChild,
}: SidebarProps): JSX.Element => {
  type Anchor = "left";

  const [state, setState] = React.useState({
    left: false,
  });

  const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
    (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      setState({ ...state, [anchor]: open });
    };

  return (
    <div className="_247FactoryNet-sidebar">
      <div className="hamburger">
        <Button
          onClick={() => {
            setState({ left: !state.left });
          }}
          sx={{ color: "#B21412" }}
        >
          <MenuIcon />
        </Button>
        <Drawer
          anchor={"left"}
          open={state["left"]}
          sx={{ backgroundColor: "#707070" }}
          onClose={toggleDrawer("left", false)}
          className="_247FactoryNet-sidebar"
        >
          <div className="sidebar">
            {data.map((item: any, key: number) => (
              <MenuItem
                key={key}
                item={item}
                navigateToFirstChild={navigateToFirstChild}
                closeSideBar={() => {
                  setState({ left: false });
                }}
              />
            ))}
          </div>
        </Drawer>{" "}
      </div>
      <div className="sidebarWrapper">
        {" "}
        <div className="sidebar">
          {data.map((item: any, key: number) => (
            <MenuItem
              key={key}
              item={item}
              navigateToFirstChild={navigateToFirstChild}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
